var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-progress position-relative p-4"},[_c('ul',{staticClass:"progressive-bar d-flex"},_vm._l((_vm.steppers),function(step,k){return _c('li',{key:k,class:_vm.current_step >= k ? 'active' : 'none'})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }